import React, { useContext } from "react";
import { connect } from "react-redux";
import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Steps,
  message,
  Divider,
  Popconfirm,
  Descriptions,
  PageHeader,
  Spin,
  Popover,
  Checkbox,
  Menu,
  Dropdown,
  Modal,
} from "antd";
// import * as XLSX from "xlsx";
import _, { size, values } from "lodash";
import TextArea from "rc-textarea";
import { userActions } from "../../_actions";
import { professionalAction } from "../../_actions/professional.actions";
import { pushNotificationService } from "../../_services/pushNotification";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { roleAction } from "../../_actions/roleby.action";
import { notificationAction } from "../../_actions/notifications.actions";
import { ArrestForm } from "../ProfessionalForm/Forms/ArrestForm";
import { BasicInformation } from "../ProfessionalForm/Forms/BasicInformation";
import { GhunhaInfomationTable } from "../ProfessionalForm/FormsTable/GhunhaInfomationTable";
import { GhunhaInfomation } from "../ProfessionalForm/Forms/GhunhaInfomation";
import { NoticeForm } from "../ProfessionalForm/Forms/NoticeFrom";
import { PreventiveForm } from "../ProfessionalForm/Forms/PreventiveForm";
import { FindFormTable } from "../ProfessionalForm/FormsTable/FindFormTable";
import { PreventiveInfomationTable } from "../ProfessionalForm/FormsTable/PreventiveInfomationTable";
import { SearchByCrimeCount } from "../ProfessionalForm/FormsTable/SearchByCrimeCount";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import { OtherInformation } from "../ProfessionalForm/Forms/OtherInformation";

const { Step } = Steps;
const { Option } = Select;
const text = "Are you sure to delete this task?";

class AddCrimeFrom extends React.Component {
  static contextType = LanguageContext;
  state = {
    is_save: false,
    checked: false,
    criminalList: [],
    findCriminalList: [],
    accusedDrawer: true,
    ghunhaDrawer: false,
    preventiveDrawer: false,
    arrestDrawer: false,
    noticeDrawer: false,
    isNoticeEdit: false,
    isGunhaEdit: false,
    isArrestEdit: false,
    resetArrestForm: true,
    newGunha: 0,
    isPreventivEdit: false,
    newPreventive: 0,
    current: 0,
    name: false,
    ghunhaInfomationData: [],
    basicInformationData: [],
    wantedHistory: [],
    otherInformationData: [],
    preventiveInformationData: [],
    editPreventiveInformationData: [],
    editPreventiveInformationIndex: null,
    editGunhaInformationData: [],
    editGunhaInformationIndex: null,
    arrestInformationData: [],
    noticeInformationData: [],
    arrestInformationIndex: null,
    isBasicInforSuccess: false,
    districts: [],
    isAccusedFormEdit: [],
    isEditForms: false,
    resetBasicForm: false,
    setCriminalViewModel: false,
    resetBaseFormRandom: 0,
    criminalActiveModel: false,
    criminalActiveReasoneValue: "",
    criminalActiveData: {},
    tableLoading: false,
    newflag: 0,
    findTextValue: "",
    findNumberValue: "",
    classActive1: false,
    classActive1: false,
    criminalListAll: [],
    exportList: [],
    bharthili: 0,
    hadthili: 0,
    criminalList1: [],
    downloadLoding: false,
    csvData: [],
    downloadLodingCSV: false,
    download_modal: false,
    address: false,
    mobileNumber: false,
    city: false,
    state_name: false,
    district_name: false,
    religion: false,
    selectdistrict: false,
    criminal_profile: false,
    gunhaCount: false,
    age: false,
    dharms: false,
    accusedPreventiveDrawer: false,
    resetPreventiveForm: true,
    preventiveAction: [],
    total: 0,
    pageSize: 10,
    masterId: "",
    currentPage: 0,
    isseach: "list",
    sadyasthitiData: [],
    PSFilledInfo: true,
    PSEnvInfo: false,
    searchType: "accused",
    selectedCity: null,
    search_find: false,
    districtName1: "",
    arrestCreateLoad: false,
    arrestUpdateLoading: false,
  };

  basicInformationRef = React.createRef();
  ghunhaInfomationRef = React.createRef();
  otherInfomationRef = React.createRef();
  preventiveInfoRef = React.createRef();
  arrestInfomationRef = React.createRef();
  noticeInformationRef = React.createRef();
  controller = new AbortController();

  onChangeCheckbox = (e) => {
    console.log("checked = ", e.target.checked);
    this.setState({ checked: e.target.checked });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.preventiveList !== this.props.preventiveList) {
      const list = this.props.preventiveList;
      this.setState({ criminalList: list });
      this.setState({ preventiveAction: this.props.preventiveAction });
    }
  }

  componentDidMount() {
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());
    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
    this.getPoliceStationWithGhatak();
    if (this.state.searchType === "accused") {
      setTimeout(() => {
        this.accusedInput?.focus();
      }, 0);
    }
  }

  getSerialNumber = (index, currentPage, itemsPerPage) => {
    return currentPage * itemsPerPage + index + 1;
  };

  clearFilterSeach = () => {
    this.setState({
      checked: false,
      searchType: "accused",
      findCriminalList: [],
      selectedPoliceStation: "",
      findNumberValue: "",
      findTextValue: "",
      search_find: false,
      criminalListAll: [],
    });
  };

  onDropdownChange = (value) => {
    this.setState(
      { searchType: value, checked: false, findCriminalList: [] },
      () => {
        if (value === "accused" || value === "crime") {
          setTimeout(() => {
            this.accusedInput?.focus();
          }, 0);
        }
      },
    );
  };

  getPoliceStationWithGhatak = () => {
    const { user } = this.props;

    professionalAction
      .getPoliceStationWithGhatak(user.id)
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await res.json();

        const cityOptions = data?.city
          ? [
              {
                id: data.city.id,
                label: `${data.city.value} (${data.city.City})`,
                value: data.city.value,
              },
            ]
          : [];

        const policeStationOptions = data?.distincts
          ? [
              {
                id: data?.distincts.id,
                label: `${data?.distincts?.value} (${data?.distincts?.DistrictName})`,
                value: data?.distincts?.value,
              },
            ]
          : [];

        this.setState({
          dataList: [...cityOptions, ...policeStationOptions],
          selectedPoliceStation: policeStationOptions[0]?.value,
        });
        this.handleSelectChange(policeStationOptions[0]?.value);
        this.setState({ districtName1: data?.distincts?.DistrictName });
      })
      .catch((error) => {})
      .finally(() => {});
  };

  errorMessage = (errorTxt) => {
    message.error(errorTxt);
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  showAccusedDrawer = () => {
    this.setState({
      accusedDrawer: true,
      resetBasicForm: true,
      isEditForms: false,
      resetBaseFormRandom: Math.random(),
      newflag: 0,
    });
  };

  onCloseAccusedDrawer = () => {
    this.setState((prevState) => ({
      accusedDrawer: false,
      basicInformationData: [],
      wantedHistory: [],
      otherInformationData: [],
      ghunhaInfomationData: [],
      editGunhaInformationData: [],
      ghunhaDrawer: false,
      accusedDrawer: false,
      current: 0,
      resetBasicForm: false,
      isEditForms: false,
      searchType: "accused",
      findCriminalList: [],
      findTextValue: "",
      checked: "",
      selectedPoliceStation: "",
      findNumberValue: "",
    }));
    this.props.history.push("/");
  };

  onClosePreventiveAccusedDrawer = () => {
    this.setState((prevState) => ({
      basicInformationData: [],
      wantedHistory: [],
      otherInformationData: [],
      ghunhaInfomationData: [],
      editGunhaInformationData: [],
      ghunhaDrawer: false,
      accusedPreventiveDrawer: false,
      current: 0,
      resetBasicForm: false,
      isEditForms: false,
    }));
  };

  showghunhaDrawer = () => {
    this.setState({
      ghunhaDrawer: true,
      newGunha: Math.floor(Math.random() * Math.floor(5)),
      isGunhaEdit: false,
    });
  };

  onghunhaDrawerClose = () => {
    this.setState({
      ghunhaDrawer: false,
    });
  };

  showarrestDrawer = () => {
    this.setState({
      arrestDrawer: true,
      newGunha: Math.floor(Math.random() * Math.floor(5)),
      isArrestEdit: false,
    });
  };

  showNoticeDrawer = () => {
    this.setState({
      noticeDrawer: true,
    });
  };
  onarrestDrawerClose = () => {
    this.setState({
      arrestDrawer: false,
    });
  };
  onNoticeDrawerClose = () => {
    this.setState({
      noticeDrawer: false,
    });
  };

  next = () => {
    if (this.state.current === 0) {
      this.basicInformationRef.current.onFinish();
    }
    if (this.state.current === 1) {
      if (this.state.ghunhaInfomationData.length) {
        this.setState({
          current: this.state.current + 1,
        });
      } else {
        this.errorMessage("किमान एक गुन्हा आवश्यक आहे");
      }
    }
  };

  prev = () => {
    if (this.state.current === 2) {
      this.otherInfomationRef.current.onFinish();
    }
    this.setState({
      current: this.state.current - 1,
    });
  };

  done = () => {
    // this.otherInfomationRef.current.onFinish();
  };

  onGunhaFormFiniesh = (data) => {
    let newEntery = {
      ...data,
      registernumberYear: data.registernumberYear
        ? moment(data.registernumberYear).format("YYYY")
        : moment(),
      districtName: this.getDistrictName(data.district),
      is_new_guna: "yes",
      userId: this.props.user.id,
    };
    this.setState((prevState) => ({
      ghunhaInfomationData: [...prevState.ghunhaInfomationData, newEntery],
      ghunhaDrawer: false,
    }));
  };

  onGunhaFormUpdate = (data) => {
    let newEntery = {
      ...data,
      registernumberYear: data.registernumberYear
        ? moment(data.registernumberYear).format("YYYY")
        : moment(),
      districtName: this.getDistrictName(data.district),
      userId: this.props.user && this.props.user.id,
    };
    let tempArray = this.state.ghunhaInfomationData;
    tempArray.splice(this.state.editGunhaInformationIndex, 1);
    this.setState((prevState) => ({
      ghunhaInfomationData: [],
      ghunhaInfomationData: [...tempArray, newEntery],
      ghunhaDrawer: false,
      editGunhaInformationIndex: null,
    }));
  };

  basicInformationFinish = (data) => {
    this.setState((prevState) => ({
      basicInformationData: [data],
      wantedHistory: [data],
    }));
    if (data) {
      this.setState({
        current: this.state.current + 1,
      });
    }
  };

  otherInformationFiniesh = (data) => {
    this.setState((prevState) => ({
      otherInformationData: [data],
    }));
  };

  uploadImage = (data) => {
    this.props.dispatch(professionalAction.uploadImage(data));
  };

  onGhunhaInfomationSave = () => {
    this.ghunhaInfomationRef.current.onFinish(true);
  };

  onGhunhaInfomationUpdate = () => {
    this.ghunhaInfomationRef.current.onFinish(false);
  };

  onGhunhaInfomationCancel = () => {
    this.setState((prevState) => ({
      ghunhaDrawer: false,
    }));
  };

  editGhunhaInfomation = (data, index) => {
    this.onCityChange(data.city, 2);
    this.setState((prevState) => ({
      editGunhaInformationData: [data],
      editGunhaInformationIndex: index,
      ghunhaDrawer: true,
      isGunhaEdit: true,
      newGunha: false,
      resetBasicForm: false,
    }));
  };

  deleteGhunhaInfomation = (data, index) => {
    let temp = this.state.ghunhaInfomationData;
    temp.splice(index, 1);
    this.setState((prevState) => ({
      ghunhaInfomationData: [...temp],
      editGunhaInformationIndex: index,
    }));
  };

  onArrestFormFiniesh = (data) => {
    setTimeout(() => {
      let values = {
        arrestInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          district:
            this.props?.user.role === "2" ? this.props?.user.districtId : null,
        },
      };
      this.props.dispatch(professionalAction.createArrestAction(values));
      message.info("Save Arrest Successfully !!");
      this.onarrestDrawerClose();
    }, 2000);
  };

  onArrestFormUpdate = (data, arrestInfo) => {
    const photoString = data?.photo.join(", ");
    data.photo = photoString;
    setTimeout(() => {
      let values = {
        arrestInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          id: arrestInfo?.id,
          district:
            this.props?.user.role === "2" ? this.props?.user.districtId : null,
        },
      };

      this.props.dispatch(
        professionalAction.updateArrestAction(values, arrestInfo?.id),
      );
      message.info("Update Successfully !!");
      this.onarrestDrawerClose();
    }, 2000);
  };

  onNoticeFormFiniesh = (data) => {
    setTimeout(() => {
      let values = {
        NoticeInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          districtId: this.props.user.role == "2" && this.props.user.districtId,
          districtName: this.props.user.role == "2" && this.state.districtName1,
        },
      };
      this.props.dispatch(professionalAction.createNoticeInformation(values));
      message.info("Save Notice Successfully !!");
      this.onNoticeDrawerClose();
    }, 2000);
  };

  onNoticeFormUpdate = (data, arrestInfo) => {
    // const photoString = data?.photo.join(", ");
    // data.photo = photoString;
    setTimeout(() => {
      let values = {
        NoticeInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          districtId: this.props.user.role == "2" && this.props.user.districtId,
          districtName: this.state.districtName1,
          id: arrestInfo?.id,
        },
      };

      this.props.dispatch(
        professionalAction.updateNoticeInformation(values, arrestInfo?.id),
      );
      message.info("Update Successfully !!");
      this.onNoticeDrawerClose();
    }, 2000);
  };

  onArrestInfomationSave = () => {
    if (this.state.arrestCreateLoad) return; // prevent double click

    this.setState({ arrestCreateLoad: true });
    this.arrestInfomationRef.current.onFinish(true);
  };

  onArrestInfomationUpdate = () => {
    if (this.state.arrestUpdateLoading) return; // prevent double click

    this.setState({ arrestUpdateLoading: true });
    this.arrestInfomationRef.current.onFinish(false);
  };

  onNoticeInfromationSave = () => {
    this.noticeInformationRef.current.onFinish(true);
  };
  onNoticeInfromationUpdate = () => {
    this.noticeInformationRef.current.onFinish(false);
  };

  onArrestInfomationCancel = () => {
    this.setState((prevState) => ({
      arrestDrawer: false,
    }));
  };
  editNoticeInformation = (data, index) => {
    this.setState((prevState) => ({
      noticeInformationData: [data],
      arrestInformationIndex: index,
      noticeDrawer: true,
      isNoticeEdit: true,
      newGunha: false,
      resetArrestForm: false,
    }));
  };

  editArrestInfomation = (data, index) => {
    this.setState((prevState) => ({
      arrestInformationData: [data],
      arrestInformationIndex: index,
      arrestDrawer: true,
      isArrestEdit: true,
      newGunha: false,
      resetArrestForm: false,
    }));
  };

  onCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };

  onKaydaChange = (actId) => {
    if (actId) {
      this.props.dispatch(professionalAction.getKalam(actId));
    }
  };

  getDistrictName = (id) => {
    const { gunhaDistricts } = this.props.professionals;
    if (gunhaDistricts && gunhaDistricts.length) {
      return (
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  onConfirm = () => {
    this.setState({
      is_save: true,
    });
    this.otherInfomationRef.current.onFinish();
    let name = this.state.basicInformationData[0].name;
    let policeName = this.state.basicInformationData[0].districtName;
    let wanted_history_data = {
      userId: this.props.user?.id || null, // safe access
      current_condition: this.state.wantedHistory[0]?.current_condition,
      current_condition_date:
        this.state.wantedHistory[0]?.current_condition_date &&
        this.state.wantedHistory[0]?.current_condition_date,
      historySheeter: this.state.wantedHistory[0]?.historySheeter,
      history_date:
        this.state.wantedHistory[0].historySheeter == 1
          ? this.state.wantedHistory[0]?.history_date
          : null,
      cityId: this.props.user.cityId,
      district: this.props.user.role === "2" && this.props.user.districtId,
    };
    setTimeout(() => {
      let data = {
        basicInformation: { ...this.state.basicInformationData[0] },
        wantedHistory: { ...wanted_history_data },
        otherInformation: { ...this.state.otherInformationData[0] },
        gunhaInformation: [...this.state.ghunhaInfomationData],
        currentuser: { ...this.props.user },
      };
      let image = this.state.otherInformationData[0].accusedImage[0];

      this.props.dispatch(professionalAction.createCriminal(data));
      userActions
        .getAppUserTokens(
          this.props && this.props.user && this.props.user.cityId,
        )
        .then((apiRes) => {
          apiRes &&
            apiRes.text().then((res) => {
              res &&
                JSON.parse(res) &&
                JSON.parse(res).map((item) => {
                  let data = {
                    token: item.appToken,
                    title: "CMIS New Criminal Added",
                    body: name + " , " + policeName,
                    image:
                      image &&
                      "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                        image,
                  };
                  // pushNotificationService
                  //   .pushNotification(data)
                  //   .then((tokenRes) => {});
                });
            });
        });
      message.info("Save Successfully !!");
      // window.location.reload();

      this.props.history.push("/");
      this.setState({ is_save: false });
      this.onCloseAccusedDrawer();
    }, 1000);
  };

  getPreventiveActionsByDateAndId = (masterId) => {
    let obj = {
      masterId: masterId,
    };
    let temp;
    notificationAction.getPreventiveActionsByDateAndId(obj).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList?.data);
          let list = criminalList?.data;
          console.log("list", list);

          if (list) {
            let temp = {
              masterid: list.masterId,
              prevetive_id: list.preventiveid,
              gunaid: list.gunaid,
              userid: this.props.user.id,
            };

            if (this.props.user.role === "4") {
              temp.city = this.props.user.cityId;
            } else if (this.props.user.role === "2") {
              temp.district = this.props.user.districtId;
              temp.city = this.props.user.cityId;
            }
            this.preventiveActionNotification(temp);
          }

          this.setState({
            notificationData: list || [],
          });
        });
    });
  };

  preventiveActionNotification = (values) => {
    notificationAction.preventiveActionNotification(values).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList);
          if (criminalList.message === "Record created successfully") {
            Modal.info({
              icon: null, // remove default icon
              title: (
                <div style={{ textAlign: "center" }}>
                  <ExclamationCircleTwoTone
                    twoToneColor="#faad14"
                    style={{ fontSize: "40px", marginBottom: "10px" }}
                  />
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginTop: "10px",
                    }}
                  >
                    अलर्ट
                  </div>
                </div>
              ),
              width: 500,
              centered: true,
              content: (
                <div
                  style={{
                    lineHeight: "1.7",
                    fontSize: "16px",
                    wordBreak: "break-word",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  <p>
                    <strong>{this.state?.notificationData?.name}</strong>{" "}
                    आरोपीवर{" "}
                    <strong>
                      {this.state?.notificationData?.preventive_name}
                    </strong>{" "}
                    प्रतिबंधक कारवाई चालू असून, त्यावर{" "}
                    <strong>
                      {moment(this.state?.notificationData?.dateTime).format(
                        "DD.MM.YYYY",
                      )}
                    </strong>{" "}
                    रोजी{" "}
                    <strong>
                      {this.state?.notificationData?.districtName}
                    </strong>{" "}
                    पोलीस ठाणे मध्ये गुन्हा दाखल झालेला आहे.
                  </p>
                </div>
              ),
              onOk() {
                console.log("OK clicked");
              },
            });
          }
        });
    });
  };
  onUpdateConfirm = () => {
    this.otherInfomationRef.current.onFinish();
    const { gunhaInfor, otherInfo } = this.props.professionals;
    // this.setState({
    //   ghunhaInfomationData: [
    //     ...this.state.ghunhaInfomationData,
    //   ],
    // });
    console.log(
      "this.state.basicInformationData[0]",
      this.state.basicInformationData[0],
    );

    setTimeout(() => {
      let wanted_history_data = {
        userId: this.props.user?.id || null, // safe access
        current_condition: this.state.wantedHistory[0]?.current_condition,
        masterId: this.state.isAccusedFormEdit[0].editId,
        current_condition_date:
          this.state.wantedHistory[0].current_condition_date &&
          this.state.wantedHistory[0].current_condition_date,
        historySheeter: this.state.wantedHistory[0].historySheeter,
        history_date:
          this.state.wantedHistory[0].historySheeter == 1
            ? this.state.wantedHistory[0].history_date
            : null,
        cityId: this.props.user.cityId,
        district: this.props.user.role === "2" && this.props.user.districtId,
      };

      let data = {
        basicInformation: { ...this.state.basicInformationData[0] },
        otherInformation: { ...this.state.otherInformationData[0] },
        wantedHistory: { ...wanted_history_data },
        gunhaInformation: [...this.state.ghunhaInfomationData],
        currentuser: { ...this.props.user },
        // this.state.basicInformationData
      };
      this.props.dispatch(
        professionalAction.updateCriminals(
          this.state.isAccusedFormEdit[0].editId,
          data,
        ),
      );

      message.info("Update Successfully!!");
      setTimeout(() => {
        this.getPreventiveActionsByDateAndId(
          this.state.isAccusedFormEdit[0].editId,
        );
      }, 2000);

      this.onCloseAccusedDrawer();
    }, 1000);
  };

  getPreventiveList = () => {
    const { report_1_startDate, report_1_endDate, preventive_action } =
      this.props;
    const startDate = moment(report_1_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_1_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    const data = {
      startDate: startDate,
      endDate: endDate,
      cityId: user.cityId,
      preventive_action: preventive_action,
    };
    professionalAction.getPreventiveList(data).then((res) => {
      res &&
        res.text().then((criminalList1) => {
          let criminal = JSON.parse(criminalList1);
          let list = criminal.results;
          let columns1 =
            list &&
            list &&
            list.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });
          this.setState({
            preventiveList: tempObj,
            criminalList: tempObj,
          });
        });
    });
  };

  onEditAccusedForm = (data) => {
    console.log("data ids", data);
    this.setState({
      userID: data.userId,
    });
    const ID = this.state.searchType === "crime" ? data?.masterId : data?.id;
    this.setState({
      masterId: ID,
    });
    let temo = this.props.dispatch(professionalAction.getCriminalsById(ID));

    temo.then((res) => {
      const { basicInfo, gunhaInfor, otherInfo, wantedHistory } = res;
      // let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
      //   return o.masterId === data.id;
      // });
      // let getEditOtherTemp = _.filter(otherInfo, (o) => {
      //   return o.masterId === data.id;
      // });
      let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
        return o.masterId === ID;
      });
      let getEditOtherTemp = _.filter(otherInfo, (o) => {
        return o.masterId === ID;
      });
      this.setState({
        basicInformationData: basicInfo,
        isAccusedFormEdit: [
          {
            // editId: data.id,
            editId: ID,
            guhnhaEditId: getEditGunhaTemp[0] && getEditGunhaTemp[0].id,
            otherEditId: getEditOtherTemp[0] && getEditOtherTemp[0].id,
            isEdit: true,
          },
        ],
        ghunhaInfomationData: [...getEditGunhaTemp],
        otherInformationData: [...getEditOtherTemp],
        isEditForms: true,
        accusedDrawer: true,
        newGunha: false,
        resetBasicForm: false,
        newflag: 1,
        wantedHistory: wantedHistory,
      });
    });
  };

  /**
   * Preventive Form
   *
   */
  editPreventiveInfomation = (data, index) => {
    this.setState((prevState) => ({
      editPreventiveInformationData: [data],
      editPreventiveInformationIndex: index,
      preventiveDrawer: true,
      isPreventiveEdit: true,
      newPreventive: false,
      resetBasicForm: false,
      resetPreventiveForm: false,
    }));
  };

  showpreventiveDrawer = () => {
    this.setState({
      preventiveDrawer: true,
      isPreventiveEdit: false,
      resetPreventiveForm: true,
    });
  };

  onpreventiveDrawerClose = () => {
    this.setState({
      preventiveDrawer: false,
    });
  };

  preventiveInformationFinish = (data) => {
    console.log("data preventive data save", data);
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
  };

  preventiveInformationUpdate = (data) => {
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
    console.log("data preventive data update", data);
  };

  onPreventiveInfomationSave = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);
    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData,
    );
    console.log(
      "newpreventiveInformationData",
      this.state.newpreventiveInformationData,
    );
    console.log("values", values);
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          ...values,
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          city: this.props?.user?.cityId,
          district: this.props?.user?.districtId,
          districtName: values.action_taken_police_station,
        },
        currentuser: { ...this.props.user },
      };
      this.props.dispatch(professionalAction.createPreventiveAction(data));
      message.info("Save Successfully !!");
      this.onpreventiveDrawerClose();
      this.onClosePreventiveAccusedDrawer();
      this.preventiveInfoRef.current.resetForm();
      setTimeout(() => {
        this.getPreventiveActionsByDateAndId(
          this.state.isAccusedFormEdit[0].editId,
        );
      }, 2000);
      // rest unchanged...
    }, 500);
  };

  onPreventiveInfomationUpdate = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();
    console.log("values edit", values);

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);

    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData[0],
    );
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          action_taken_police_station: values.action_taken_police_station,
          city: this.props?.user?.cityId,
          district: this.props?.user?.districtId,
          districtName: values.action_taken_police_station,
        },
        currentuser: { ...this.props.user },
      };

      this.props.dispatch(
        professionalAction.updatePreventive(
          this.state.editPreventiveInformationData[0].id,
          data,
        ),
      );
      message.info("Update Successfully !!");
      this.onpreventiveDrawerClose();
      this.onClosePreventiveAccusedDrawer();
      setTimeout(() => {
        this.getPreventiveActionsByDateAndId(
          this.state.isAccusedFormEdit[0].editId,
        );
      }, 2000);
      this.setState({ preventiveInformationData: [] });
      // rest unchanged...
    }, 500);
  };

  onPreventiveViewAccusedForm = (data) => {
    this.setState({ preventiveInformationData: [] });
    professionalAction.getPreventiveToolByID(data).then((res) => {
      res &&
        res.text().then((criminalList) => {
          this.setState({
            preventiveInformationData: criminalList && JSON.parse(criminalList),
          });
        });
    });

    this.setState({
      userID: data.userId,
    });

    this.setState({
      isAccusedFormEdit: [
        {
          editId: data,
          isEdit: true,
        },
      ],
      isEditForms: true,
      accusedPreventiveDrawer: true,
      newPreventive: false,
      resetBasicForm: false,
      newflag: 1,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  onCriminalActiveStatus = (data) => {
    if (data) {
      this.setState({
        criminalActiveModel: true,
        criminalActiveData: data,
      });
    }
  };

  onCriminalActiveStatusCancel = () => {
    this.setState({
      criminalActiveModel: false,
      criminalActiveData: {},
    });
  };

  onCriminalActiveStatusChange = () => {
    let data = {
      activeUser: this.state.criminalActiveData.activeUser === 1 ? 0 : 1,
      activeStatusReason: this.state.criminalActiveReasoneValue,
    };

    if (this.state.criminalActiveData && this.state.criminalActiveData.id) {
      professionalAction
        .updateCriminalActiveStatus(this.state.criminalActiveData.id, data)
        .then((res) => {
          this.setState({
            criminalActiveModel: false,
            activeStatusReason: "",
          });
        });
    }
  };

  onCriminalActiveInputChange = (evt) => {
    this.setState({
      criminalActiveReasoneValue: evt.target.value,
    });
  };

  showBasicForm = () => {
    this.setState({
      newflag: 1,
    });
  };

  onChangeText = (values) => {
    if (values) {
      this.setState({
        findTextValue: values,
      });
    }
  };

  onChangeNumber = (values) => {
    if (values) {
      this.setState({
        findNumberValue: values.target.value,
      });
    }
  };

  showDownloadModel = () => {
    this.setState({ download_modal: true });
  };

  closeDownloadModel = () => {
    this.setState({ download_modal: false });
  };

  handleAllCheckboxChange = () => {
    this.setState((prevState) => ({
      all: !prevState.all, // Toggle the all state
    }));
  };

  handleCheckboxNameChange = (e) => {
    this.setState((prevState) => ({
      name: !prevState.name,
    }));
  };

  handleCheckboxAddress = (e) => {
    this.setState((prevState) => ({
      address: !prevState.address,
    }));
  };

  hanldeCheckboxMobileNumber = (e) => {
    this.setState((prevState) => ({
      mobileNumber: !prevState.mobileNumber,
    }));
  };

  handleCheckboxCity = (e) => {
    this.setState((prevState) => ({
      city: !prevState.city,
    }));
  };

  hanldeCheckboxState = (e) => {
    this.setState((prevState) => ({
      state_name: !prevState.state_name,
    }));
  };

  handleCheckboxdistrictName = (e) => {
    this.setState((prevState) => ({
      district_name: !prevState.district_name,
    }));
  };

  handleCheckboxReligion = (e) => {
    this.setState((prevState) => ({
      religion: !prevState.religion,
    }));
  };

  handleCheckboxCriminalProfile = (e) => {
    this.setState((prevState) => ({
      criminal_profile: !prevState.criminal_profile,
    }));
  };

  handleCheckboxGunhaCount = (e) => {
    this.setState((prevState) => ({
      gunhaCount: !prevState.gunhaCount,
    }));
  };

  hanldeCheckboxAge = (e) => {
    this.setState((prevState) => ({
      age: !prevState.age,
    }));
  };

  handleCheckboxdharms = (e) => {
    this.setState((prevState) => ({
      dharms: !prevState.dharms,
    }));
  };

  showBasicForm = () => {
    this.setState({
      newflag: 1,
    });
  };

  showBasicInformation = () => {
    if (this.state.findTextValue) {
      this.setState({
        tableLoading: true,
      });
      professionalAction
        .getCriminalsTableInfo(
          "cityId",
          this.props.user.cityId,
          this.controller.signal,
        )
        .then((res) => {
          res &&
            res.text().then((criminalListAll) => {
              this.setState({
                criminalListAll: criminalListAll && JSON.parse(criminalListAll),
                tableLoading: false,
              });
              const filtered = this.state.criminalListAll.filter((a) => {
                //return a.name.toLowerCase() === this.state.findTextValue.toLowerCase();
                return a.name.includes(this.state.findTextValue);
              });
              this.setState({
                findCriminalList: filtered,
              });
            });
        });
    }
  };

  searchHistory = () => {
    const registernumber = this.state.findNumberValue;
    const selectedPoliceStation = this.state.selectedPoliceStation;
    const searchBody = {
      type: "crime name",
      search_text: this.state.findTextValue,
      userid: this.props?.user.id,
      district: this.props?.user?.districtId,
      districtName: this.state.districtName1,
    };
    const searchBody1 = {
      type: "crime count",
      search_text: registernumber,
      userid: this.props?.user.id,
      district: this.props?.user?.districtId,
      districtName: this.state.districtName1,
    };
    professionalAction
      .postSearchHistory(registernumber ? searchBody1 : searchBody)
      .then((res) => {
        console.log("res", res);
      });
  };
  showBasicInformationbyName = () => {
    const { searchType } = this.state;
    if (this.state.findTextValue) {
      this.setState({
        tableLoading: true,
        search_find: true,
      });
      console.log(" this.props.user", this.props.user);
      const temp = {
        cityid: this.props.user.cityId,
        district: this.props.user.districtId,
        searchText: searchType === "accused" && this.state.findTextValue,
        mobile_no: searchType === "mobile_no" && this.state.findTextValue,
        adhaar_number:
          searchType === "adhaar_number" && this.state.findTextValue,
        page: this.state.currentPage,
        size: this.state.pageSize,
      };

      professionalAction.getCriminalsTableInfobyNameNew(temp).then((res) => {
        res &&
          res.text().then((criminalListAll) => {
            const res = criminalListAll && JSON.parse(criminalListAll);
            this.setState({
              criminalListAll: res.results,
              tableLoading: false,
            });

            this.setState({
              findCriminalList: res.results,
              totalNew: res.results.length,
            });
          });
      });
    }
  };

  handleSelectChange = (value) => {
    const selected = this.state.dataList.find((item) => item.value === value);
    this.setState({
      selectedPoliceStation: selected,
    });
  };

  searchByCrimeCount = () => {
    const registernumber = this.state.findNumberValue;
    const selectedPoliceStation = this.state.selectedPoliceStation;
    const body = {
      registernumber: registernumber,
      value: selectedPoliceStation?.value,
      id: selectedPoliceStation.id,
    };
    if (this.state.findNumberValue) {
      this.setState({
        tableLoading: true,
        search_find: true,
      });
      professionalAction.searchByGunhaCount(body).then((res) => {
        res &&
          res.text().then((criminalListAll) => {
            const res = criminalListAll && JSON.parse(criminalListAll);
            this.setState({
              criminalListAll: res,
              tableLoading: false,
            });
            this.setState({
              findCriminalList: res,
              totalNew: res?.totalItems,
            });
          });
      });
    }
  };

  render() {
    const {
      criminalViewList,
      pc_cities,
      loading,
      pc_crimetypes,
      pc_crimetitles,
    } = this.props.professionals;
    const { professionals, user } = this.props;
    const {
      all,
      name,
      mobileNumber,
      state_name,
      city,
      address,
      district_name,
      religion,
      criminal_profile,
      gunhaCount,
      age,
      criminalList,
      criminalList1,
      csvData,
      searchType,
      dataList,
    } = this.state;
    const { t } = this.context;
    const steps = [
      {
        title: t("accused_details"),
        content: "First-content",
        flag: 1,
      },
      {
        title: t("crime_details"),
        content: "Second-content",
        flag: 2,
      },
      {
        title: t("accused_other_information"),
        content: "Last-content",
        flag: 3,
      },
    ];
    return (
      <div>
        <Drawer
          title="आरोपीची माहिती"
          width={900}
          maskClosable={false}
          visible={this.state.accusedDrawer}
          onClose={this.onCloseAccusedDrawer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onCloseAccusedDrawer}
                    style={{ marginRight: 8 }}
                  >
                    {t("cancel")}
                  </Button>
                </div>

                <div>
                  {this.state.current > 0 && (
                    <Button
                      onClick={() => this.prev()}
                      style={{ marginRight: 8 }}
                    >
                      {t("previous")}
                    </Button>
                  )}
                  {this.state.current < steps.length - 1 && (
                    <Button type="primary" onClick={() => this.next()}>
                      {t("next")}
                    </Button>
                  )}
                  {this.state.current === steps.length - 1 &&
                    // onClick={() => this.done()}

                    (this.state.isEditForms ? (
                      // <Popconfirm
                      //   placement="topLeft"
                      //   title={text}
                      //   onConfirm={this.onUpdateConfirm}
                      //   okText="Yes"
                      //   cancelText="No"
                      // >
                      //   <Button onClick={this.onUpdateConfirm} type="primary">Update</Button>
                      // </Popconfirm>
                      <Button onClick={this.onUpdateConfirm} type="primary">
                        {t("update")}
                      </Button>
                    ) : (
                      // <Popconfirm
                      //   placement="topLeft"
                      //   title={text}
                      //   onConfirm={this.onConfirm}
                      //   okText="Yes"
                      //   cancelText="No"
                      // >
                      //   <Button onClick={this.onConfirm} type="primary">Done</Button>
                      // </Popconfirm>
                      <Button
                        disabled={this.state.is_save === true}
                        onClick={this.onConfirm}
                        type="primary"
                      >
                        {t("done")}
                      </Button>
                    ))}
                </div>
              </div>
            </div>
          }
        >
          <Steps current={this.state.current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content mb-4" style={{ marginTop: "30px" }}>
            <Divider />
            {steps[this.state.current].flag === 1 ? (
              this.state.newflag === 0 ? (
                <PageHeader
                  className="site-page-header"
                  ghost={false}
                  onBack={false}
                  title={"आरोपी शोधा"}
                >
                  {/* <Descriptions size="small" column={2}>
                    <Descriptions.Item>
                      <Form.Item
                        name="name"
                        label="आरोपी शोधा"
                        rules={[
                          { required: true, message: "Please enter name" },
                        ]}
                      >
                        <Input
                          placeholder="Please enter name"
                          onChange={(val) => this.onChangeText(val)}
                        />
                      </Form.Item>
                      <Button
                        key="1"
                        type="primary"
                        onClick={this.showBasicInformationbyName}
                      >
                        Find
                      </Button>
                    </Descriptions.Item>
                  </Descriptions> */}
                  <Descriptions size="small" column={2}>
                    <Descriptions.Item>
                      <Form.Item
                        label={""}
                        rules={[
                          {
                            required: true,
                            message: "Please select a search type",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select search type"
                          value={this.state.searchType}
                          onChange={this.onDropdownChange}
                          defaultValue="accused"
                        >
                          <Option value="accused">आरोपी शोधा</Option>
                          <Option value="crime">गुन्हा शोधा</Option>
                          <Option value="mobile_no">
                            {t("mobile_number")}
                          </Option>
                          <Option value="adhaar_number">
                            {t("aadhaar_number")}
                          </Option>
                        </Select>
                      </Form.Item>
                      {searchType === "mobile_no" ||
                      searchType === "adhaar_number" ? (
                        <>
                          <Form.Item
                            name="findTextValue"
                            style={{ marginLeft: "5px" }}
                            rules={[
                              { required: true, message: "Please enter name" },
                            ]}
                          >
                            <Input
                              ref={(ref) => (this.accusedInput = ref)}
                              placeholder="Please enter name"
                              value={this.state.findTextValue}
                              onChange={(e) =>
                                this.onChangeText(e.target.value)
                              }
                              style={{ caretColor: "#1677ff" }}
                            />
                          </Form.Item>
                        </>
                      ) : searchType === "accused" ? (
                        <Form.Item
                          name="findTextValue"
                          style={{ marginLeft: "5px" }}
                          rules={[
                            { required: true, message: "Please enter name" },
                          ]}
                        >
                          <Input
                            ref={(ref) => (this.accusedInput = ref)}
                            placeholder="Please enter name"
                            value={this.state.findTextValue}
                            onChange={(e) => this.onChangeText(e.target.value)}
                            style={{ caretColor: "#1677ff" }}
                          />
                        </Form.Item>
                      ) : (
                        <>
                          <Form.Item
                            name="registernumber"
                            style={{ marginLeft: "5px" }}
                            rules={[
                              { required: true, message: "Please enter count" },
                            ]}
                          >
                            <Input
                              ref={(ref) => (this.accusedInput = ref)}
                              type="number"
                              placeholder="Please enter count"
                              onChange={(val) => this.onChangeNumber(val)}
                            />
                          </Form.Item>
                          <Form.Item
                            style={{ paddingLeft: "5px" }}
                            rules={[
                              {
                                required: true,
                                message: "Please select a police station",
                              },
                            ]}
                          >
                            <Select
                              style={{ width: 300 }}
                              placeholder="Select value"
                              onChange={this.handleSelectChange}
                              value={this.state.selectedPoliceStation}
                              defaultValue={this.state.selectedPoliceStation}
                            >
                              {dataList &&
                                Array.isArray(dataList) &&
                                dataList.map((item) => (
                                  <Select.Option
                                    key={item.id}
                                    value={item.value}
                                  >
                                    {item.label}
                                  </Select.Option>
                                ))}
                            </Select>
                          </Form.Item>
                        </>
                      )}
                      {this.state.searchType &&
                        ((this.state.findNumberValue &&
                          this.state.selectedPoliceStation) ||
                          this.state.findTextValue) && (
                          <Button
                            key="1"
                            type="primary"
                            className="margin-left-1 modern-button modern-button-success"
                            onClick={() => {
                              this.searchHistory();
                              searchType === "accused" ||
                              searchType === "mobile_no" ||
                              searchType === "adhaar_number"
                                ? this.showBasicInformationbyName()
                                : this.searchByCrimeCount();
                            }}
                          >
                            {t("find")}
                          </Button>
                        )}

                      {this.state.findCriminalList.length > 0 && (
                        <Button
                          onClick={() => this.clearFilterSeach()}
                          className="modern-button modern-button-danger"
                          style={{
                            minWidth: "96px",
                            height: 40,
                            marginLeft: "10px",
                          }}
                        >
                          {t("clear")}
                        </Button>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                  <Divider />
                  <Spin spinning={this.state.tableLoading}>
                    {searchType === "accused" ||
                    searchType === "mobile_no" ||
                    searchType === "adhaar_number" ? (
                      <FindFormTable
                        onEditAccusedForm={this.onEditAccusedForm}
                        onViewAccusedForm={this.onViewAccusedForm}
                        criminalRecords={this.state.findCriminalList}
                        onPreventiveViewAccusedForm={
                          this.onPreventiveViewAccusedForm
                        }
                        usersData={user}
                        current={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.state.totalNew}
                        handlePageChange={this.handlePageChangeNew}
                        handlePageSizeChange={this.handlePageSizeChangeNew}
                        getSerialNumber={this.getSerialNumber}
                        searchType={this.state.searchType}
                        searcData={this.state.findTextValue}
                        city={this?.props?.user?.cityId}
                        district={this?.props?.user.districtId}
                        tableLoading={this.state.tableLoading}
                        userid={this.props?.user.id}
                        districtName={this.state.districtName1}
                        findTextValue={this.state.findTextValue}
                        pc_cities={pc_cities}
                      ></FindFormTable>
                    ) : (
                      <SearchByCrimeCount
                        onEditAccusedForm={this.onEditAccusedForm}
                        onViewAccusedForm={this.onViewAccusedForm}
                        criminalRecords={this.state.findCriminalList}
                        onPreventiveViewAccusedForm={
                          this.onPreventiveViewAccusedForm
                        }
                        usersData={user}
                        current={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.state.totalNew}
                        handlePageChange={this.handlePageChangeNew}
                        handlePageSizeChange={this.handlePageSizeChangeNew}
                        getSerialNumber={this.getSerialNumber}
                        searchType={this.state.searchType}
                        registernumber={this.state.findNumberValue}
                        selectedPoliceStation={this.state.selectedPoliceStation}
                        tableLoading={this.state.tableLoading}
                        userid={this.props?.user.id}
                        districtName={this.state.districtName1}
                        district={this?.props?.user.districtId}
                      ></SearchByCrimeCount>
                    )}
                  </Spin>
                  <Divider />
                  {this.state.search_find && (
                    <Checkbox
                      checked={this.state.checked}
                      onChange={this.onChangeCheckbox}
                    >
                      {t("searched_accused_not_found")}
                    </Checkbox>
                  )}

                  {this.state.checked && (
                    <Button key="1" type="primary" onClick={this.showBasicForm}>
                      आरोपी समाविष्ट करा
                    </Button>
                  )}
                </PageHeader>
              ) : (
                <BasicInformation
                  ref={this.basicInformationRef}
                  basicInformationFinish={this.basicInformationFinish}
                  basicInformationData={this.state.basicInformationData}
                  wantedHistory={this.state.wantedHistory}
                  dataStates={this.props.professionals}
                  onCityChange={this.onCityChange}
                  isEditForms={this.state.isEditForms}
                  uploadImage={this.uploadImage}
                  resetBasicForm={this.state.resetBasicForm}
                ></BasicInformation>
              )
            ) : steps[this.state.current].flag === 2 ? (
              <div>
                <Button type="primary" onClick={this.showghunhaDrawer}>
                  आणखी गुन्हा जोडा
                </Button>
                {this.state.ghunhaInfomationData.length ? (
                  <GhunhaInfomationTable
                    data={this.state.ghunhaInfomationData}
                    editGhunhaInfomation={this.editGhunhaInfomation}
                    deleteGhunhaInfomation={this.deleteGhunhaInfomation}
                    editArrestInfomation={this.editArrestInfomation}
                    editNoticeInformation={this.editNoticeInformation}
                    professionals={this.props.professionals}
                    isEditForms={this.state.isEditForms}
                  ></GhunhaInfomationTable>
                ) : null}
                <Drawer
                  title="गुन्हा"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onghunhaDrawerClose}
                  visible={this.state.ghunhaDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onGhunhaInfomationCancel}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isGunhaEdit ? (
                        <Button
                          onClick={this.onGhunhaInfomationSave}
                          type="primary"
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onGhunhaInfomationUpdate}
                          type="primary"
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <GhunhaInfomation
                    ref={this.ghunhaInfomationRef}
                    newGunha={this.state.newGunha}
                    onGunhaFormFiniesh={this.onGunhaFormFiniesh}
                    onGunhaFormUpdate={this.onGunhaFormUpdate}
                    openKalamAndKaydaDrawer={this.openKalamAndKaydaDrawer}
                    dataStates={this.props.professionals}
                    editData={this.state.editGunhaInformationData}
                    onCityChange={this.onCityChange}
                    onKaydaChange={this.onKaydaChange}
                    masterId={this.state.masterId}
                    role={this.props.user.role}
                    city={this.props.user.cityId}
                    id={this.props.user.id}
                    districtId={
                      this.state.selectdistrict
                        ? this.props.user.districtId
                        : ""
                    }
                  ></GhunhaInfomation>
                </Drawer>
                <Drawer
                  title="अटक फॉर्म"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onarrestDrawerClose}
                  visible={this.state.arrestDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onArrestInfomationCancel}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isArrestEdit ? (
                        <Button
                          onClick={this.onArrestInfomationSave}
                          type="primary"
                          disabled={this.state.arrestCreateLoad}
                          loading={this.state.arrestCreateLoad}
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onArrestInfomationUpdate}
                          type="primary"
                          disabled={this.state.arrestUpdateLoading}
                          loading={this.state.arrestUpdateLoading}
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <ArrestForm
                    ref={this.arrestInfomationRef}
                    newGunha={this.state.newGunha}
                    onArrestFormFiniesh={this.onArrestFormFiniesh}
                    onArrestFormUpdate={this.onArrestFormUpdate}
                    dataStates={this.props.professionals}
                    editData={this.state.arrestInformationData}
                    onCityChange={this.onCityChange}
                    sadyasthitiData={this.state.sadyasthitiData}
                    role={this.props?.user.role}
                    district={
                      this.props?.user?.role === "2" &&
                      this.props?.user?.districtId
                    }
                  ></ArrestForm>
                </Drawer>
                <Drawer
                  title="नोटीस"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onNoticeDrawerClose}
                  visible={this.state.noticeDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onNoticeDrawerClose}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isNoticeEdit ? (
                        <Button
                          onClick={this.onNoticeInfromationSave}
                          type="primary"
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onNoticeInfromationUpdate}
                          type="primary"
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <NoticeForm
                    ref={this.noticeInformationRef}
                    newGunha={this.state.newGunha}
                    onNoticeFormFiniesh={this.onNoticeFormFiniesh}
                    onNoticeInfromationFormUpdate={this.onNoticeFormUpdate}
                    dataStates={this.props.professionals}
                    editData={this.state.noticeInformationData}
                    onCityChange={this.onCityChange}
                    role={this.props.user.role}
                    district={user?.districtId}
                  />
                </Drawer>
              </div>
            ) : steps[this.state.current].flag === 3 ? (
              <div>
                <OtherInformation
                  ref={this.otherInfomationRef}
                  uploadImage={this.uploadImage}
                  otherInformationData={this.state.otherInformationData}
                  otherInformationFiniesh={this.otherInformationFiniesh}
                  isEditForms={this.state.isEditForms}
                ></OtherInformation>
              </div>
            ) : (
              ""
            )}
          </div>
        </Drawer>

        {/* <Button type="primary" onClick={this.showCriminalViewModel}>
          Open Modal of 1000px width
        </Button> */}
        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={professionals}
            preventiveAction={this.state.preventiveAction}
          ></ViewFormModel>
        </Modal>

        <Modal
          title="Reason"
          visible={this.state.criminalActiveModel}
          onOk={this.onCriminalActiveStatusChange}
          onCancel={this.onCriminalActiveStatusCancel}
        >
          <TextArea
            rows={4}
            value={this.state.criminalActiveReasoneValue}
            onChange={this.onCriminalActiveInputChange}
            style={{ width: "100%" }}
          />
        </Modal>
        <Modal
          title="Download"
          width={50 + "%"}
          top
          visible={this.state.download_modal}
          onOk={this.closeDownloadModel}
          onCancel={this.closeDownloadModel}
        >
          <>
            <Row>
              <Col lg={6}>
                <Checkbox
                  value="All"
                  disabled={
                    name ||
                    address ||
                    city ||
                    state_name ||
                    religion ||
                    criminal_profile ||
                    gunhaCount ||
                    age ||
                    mobileNumber
                  }
                  checked={all}
                  onChange={this.handleAllCheckboxChange}
                >
                  सर्व
                </Checkbox>
              </Col>
              <Col lg={6}>
                <Checkbox
                  value="Name"
                  checked={name}
                  disabled={all}
                  onChange={(e) =>
                    this.handleCheckboxNameChange(e.target.value)
                  }
                >
                  नाव
                </Checkbox>
              </Col>
              <Col lg={6}>
                <Checkbox
                  value="mobile"
                  checked={mobileNumber}
                  disabled={all}
                  onChange={(e) =>
                    this.hanldeCheckboxMobileNumber(e.target.value)
                  }
                >
                  फोन नंबर
                </Checkbox>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Checkbox
                  checked={address}
                  disabled={all}
                  onChange={(e) => this.handleCheckboxAddress(e.target.value)}
                >
                  पत्ता
                </Checkbox>
              </Col>
              <Col lg={6}>
                <Checkbox
                  checked={state_name}
                  disabled={all}
                  onChange={(e) => this.hanldeCheckboxState(e.target.value)}
                >
                  राज्य
                </Checkbox>
              </Col>
              <Col lg={6}>
                <Checkbox
                  disabled={all}
                  checked={district_name}
                  onChange={(e) =>
                    this.handleCheckboxdistrictName(e.target.value)
                  }
                >
                  जिल्ह्याचे नाव
                </Checkbox>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Checkbox
                  checked={city}
                  disabled={all}
                  onChange={(e) => this.handleCheckboxCity(e.target.value)}
                >
                  शहर
                </Checkbox>
              </Col>
              <Col span={6}>
                <Checkbox
                  checked={religion}
                  disabled={all}
                  onChange={(e) => this.handleCheckboxReligion(e.target.value)}
                >
                  धर्म
                </Checkbox>
              </Col>
              <Col span={6}>
                <Checkbox
                  checked={criminal_profile}
                  disabled={all}
                  onChange={(e) =>
                    this.handleCheckboxCriminalProfile(e.target.value)
                  }
                >
                  फोटो
                </Checkbox>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Checkbox
                  // value={gunhaCount}
                  disabled={all}
                  onChange={(e) =>
                    this.handleCheckboxGunhaCount(e.target.value)
                  }
                  checked={gunhaCount}
                >
                  एकूण गुन्हा
                </Checkbox>
              </Col>
              <Col span={6}>
                <Checkbox
                  checked={age}
                  disabled={all}
                  onChange={this.hanldeCheckboxAge}
                >
                  वय
                </Checkbox>
              </Col>
            </Row>
          </>
        </Modal>

        <Drawer
          title="प्रोफेशनल क्रिमिनल Preventive (प्रतिबंधक कारवाही)"
          width={800}
          maskClosable={false}
          closable={false}
          onClose={this.onClosePreventiveAccusedDrawer}
          visible={this.state.accusedPreventiveDrawer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onClosePreventiveAccusedDrawer}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
                {/* <div>
                <Button
                  onClick={this.onPreventiveInfomationSave}
                  type="primary" >
                   Save
                </Button>
                </div> */}
              </div>
            </div>
          }
        >
          <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
            <Button
              type="primary"
              style={{ marginBottom: "5px" }}
              onClick={this.showpreventiveDrawer}
            >
              प्रतिबंधक कारवाही जोडा
            </Button>
            {this.state.preventiveInformationData.length ? (
              <PreventiveInfomationTable
                data={this.state.preventiveInformationData}
                editPreventiveInfomation={this.editPreventiveInfomation}
                //deleteGhunhaInfomation={this.deleteGhunhaInfomation}
                professionals={this.props.professionals}
                isEditForms={this.state.isEditForms}
                preventiveAction={this.state.preventiveAction}
                role={this.props.user.role}
                user={this.props.user}
              ></PreventiveInfomationTable>
            ) : null}

            <Drawer
              title="प्रतिबंधक कारवाही"
              width={800}
              maskClosable={false}
              closable={false}
              onClose={this.onpreventiveDrawerClose}
              visible={this.state.preventiveDrawer}
              footer={
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Button
                    onClick={this.onpreventiveDrawerClose}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                  {!this.state.isPreventiveEdit ? (
                    <Button
                      onClick={this.onPreventiveInfomationSave}
                      type="primary"
                      htmlType="submit"
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      onClick={this.onPreventiveInfomationUpdate}
                      type="primary"
                      htmlType="submit"
                    >
                      Update
                    </Button>
                  )}
                </div>
              }
            >
              <PreventiveForm
                ref={this.preventiveInfoRef}
                preventiveInformationFinish={this.preventiveInformationFinish}
                preventiveInformationUpdate={this.preventiveInformationUpdate}
                preventiveInformationData={this.state.preventiveInformationData}
                editPreventiveInformationData={
                  this.state.editPreventiveInformationData
                }
                dataStates={this.props.professionals}
                isEditForms={this.state.isEditForms}
                resetPreventiveForm={this.state.resetPreventiveForm}
                preventiveAction={this.state.preventiveAction}
                role={user?.role}
                district={user?.districtId}
                user={this.props.user}
              ></PreventiveForm>
            </Drawer>
          </div>
        </Drawer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedAddCrimeFrom = connect(mapStateToProps)(AddCrimeFrom);
export { connectedAddCrimeFrom as AddCrimeFrom };
